import script from "./repair-type-detial-block.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-type-detial-block.vue?vue&type=script&lang=ts&setup=true"

import "./repair-type-detial-block.vue?vue&type=style&index=0&id=0fb30c54&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb30c54"]])

export default __exports__